import React from "react";
import { interpolate, useCurrentFrame, useVideoConfig } from "remotion";

const PARTICLES: Array<{
  left: string;
  size: number;
  opacity: number;
  offset: number;
  swayAmp: number;
  swayOffset: number;
}> = [
  { left: "8%", size: 2, opacity: 0.35, offset: 0, swayAmp: 18, swayOffset: 0 },
  {
    left: "18%",
    size: 3,
    opacity: 0.5,
    offset: 30,
    swayAmp: 12,
    swayOffset: 20,
  },
  {
    left: "28%",
    size: 2,
    opacity: 0.3,
    offset: 60,
    swayAmp: 20,
    swayOffset: 40,
  },
  {
    left: "38%",
    size: 4,
    opacity: 0.45,
    offset: 90,
    swayAmp: 10,
    swayOffset: 60,
  },
  {
    left: "48%",
    size: 2,
    opacity: 0.55,
    offset: 120,
    swayAmp: 22,
    swayOffset: 80,
  },
  {
    left: "58%",
    size: 3,
    opacity: 0.4,
    offset: 20,
    swayAmp: 14,
    swayOffset: 100,
  },
  {
    left: "68%",
    size: 5,
    opacity: 0.32,
    offset: 50,
    swayAmp: 16,
    swayOffset: 120,
  },
  {
    left: "78%",
    size: 2,
    opacity: 0.6,
    offset: 80,
    swayAmp: 18,
    swayOffset: 140,
  },
  {
    left: "88%",
    size: 3,
    opacity: 0.42,
    offset: 110,
    swayAmp: 12,
    swayOffset: 160,
  },
  {
    left: "13%",
    size: 4,
    opacity: 0.38,
    offset: 140,
    swayAmp: 20,
    swayOffset: 10,
  },
  {
    left: "53%",
    size: 2,
    opacity: 0.5,
    offset: 170,
    swayAmp: 15,
    swayOffset: 30,
  },
  {
    left: "73%",
    size: 3,
    opacity: 0.45,
    offset: 200,
    swayAmp: 11,
    swayOffset: 50,
  },
];

export const LuxuryBackground: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // Slow shimmer rotation — one full rotation every ~600 frames
  const shimmerRotation = interpolate(frame, [0, 600], [0, 360], {
    extrapolateRight: "wrap",
  });

  // Shimmer translateX sway
  const shimmerX = interpolate(frame % 300, [0, 150, 300], [-30, 30, -30], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#0a0806",
        overflow: "hidden",
      }}
    >
      {/* Radial vignette glow */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(ellipse at 50% 50%, rgba(201,168,76,0.04) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />

      {/* Top gold horizontal line */}
      <div
        style={{
          position: "absolute",
          top: "15%",
          left: "5%",
          width: "90%",
          height: "1px",
          background: "rgba(201,168,76,0.2)",
          pointerEvents: "none",
        }}
      />

      {/* Bottom gold horizontal line */}
      <div
        style={{
          position: "absolute",
          bottom: "15%",
          left: "5%",
          width: "90%",
          height: "1px",
          background: "rgba(201,168,76,0.2)",
          pointerEvents: "none",
        }}
      />

      {/* Animated gold particles */}
      {PARTICLES.map((p, i) => {
        // Each particle drifts upward over 240 frames with its own offset
        const cycleFrame = (frame + p.offset) % 240;
        const top = interpolate(cycleFrame, [0, 240], [1920, -50]);
        const sway = Math.sin(((frame + p.swayOffset) / fps) * 0.8) * p.swayAmp;

        return (
          <div
            key={i}
            style={{
              position: "absolute",
              left: `calc(${p.left} + ${sway}px)`,
              top: `${top}px`,
              width: `${p.size}px`,
              height: `${p.size}px`,
              borderRadius: "50%",
              background: "#c9a84c",
              opacity: p.opacity,
              pointerEvents: "none",
            }}
          />
        );
      })}

      {/* Shimmer diagonal streak */}
      <div
        style={{
          position: "absolute",
          top: "30%",
          left: `calc(50% + ${shimmerX}px)`,
          width: "2px",
          height: "200px",
          background:
            "linear-gradient(180deg, transparent, rgba(232,201,109,0.3), transparent)",
          transform: `rotate(${shimmerRotation}deg)`,
          transformOrigin: "center center",
          pointerEvents: "none",
        }}
      />
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
